import { IS_DEV, PAYMENT_API_OVERRIDE } from "./constants";

export const APP_BASE_URL = "https://account.aftershoot.com";
export const API_BASE_URL_PROD = "https://api.aftershoot.co";
export const API_BASE_URL_PRE_PROD = "https://preproduction.aftershoot.co";
export const API_BASE_URL_STAGE = "https://stage.aftershoot.dev";
export const GALLERY_APP_BASE_URL = "https://galleries.aftershoot.com";

const PAYMENT_V2_BASE_URL_PRE_PROD =
  "https://annual-ledger---payments-v2-5qagnz42ja-uc.a.run.app/payments";

export const PAYMENT_V2_BASE_URL =
  PAYMENT_API_OVERRIDE ||
  (IS_DEV ? PAYMENT_V2_BASE_URL_PRE_PROD : `${API_BASE_URL_PROD}/payments`);

export const PAYMENT_V2_ENDPOINT_V1 = `${PAYMENT_V2_BASE_URL}/v1`;
export const PAYMENT_V2_ENDPOINT_V2 = `${PAYMENT_V2_BASE_URL}/v2`;

export const PAYMENT_SERVICE_BASE_URL = PAYMENT_V2_ENDPOINT_V1;

export const REFERRAL_BASE_URL =
  "https://referral-service-dev-5qagnz42ja-uc.a.run.app/v1/referral";

export const CLOUD_FUNCTION_BASE_URL =
  "https://us-central1-aftershoot-co.cloudfunctions.net";

export const GET_PROFILE_URL = IS_DEV
  ? "https://profile-marketplace-stage-953041219166.us-central1.run.app/v1/marketplace-profile?type=get"
  : "https://marketplace.aftershoot.ai/v1/marketplace-profile?type=get";

export const BUY_PROFILE_URL = IS_DEV
  ? "https://profile-marketplace-stage-953041219166.us-central1.run.app/v1/user-marketplace-profile?type=buy"
  : "https://marketplace.aftershoot.ai/v1/user-marketplace-profile?type=buy";

export const SET_DOWNLOAD_URL = IS_DEV
  ? "https://profile-marketplace-stage-953041219166.us-central1.run.app/v1/user-marketplace-profile?type=set-downloaded"
  : "https://marketplace.aftershoot.ai/v1/user-marketplace-profile?type=set-downloaded";

export const STRIPE_BASE_URL = "https://secure.aftershoot.com/b";

export const ADD_PAYMENT_METHOD =
  "https://api.aftershoot.ai/handler/get-portal";

export const GET_CARD_DETAILS = "https://api.aftershoot.ai/handler/getcards";

export const PROFILE_MANAGER_BASE_URL = IS_DEV
  ? "https://stage.aftershoot.dev/profile-manager/v1"
  : "https://api.aftershoot.co/profile-manager/v1";

export const USER_API =
  "https://us-central1-aftershoot-co.cloudfunctions.net/website-api-for-data";

export const USER_ENDPOINT_BASE = "https://api.aftershoot.co/users/v1";

export const USERS_GDPR_BASE_URL = IS_DEV
  ? "https://stage.aftershoot.dev/users/v1/gdpr"
  : `${USER_ENDPOINT_BASE}/gdpr`;

export const GET_GOOGLE_CUSTOM_TOKEN =
  "https://us-central1-aftershoot-co.cloudfunctions.net/firebase-custom-token";

export const GALLERY_PRICING_PATH = "/gallery/pricing";

export const GALLERY_PRICING_URL = `${GALLERY_APP_BASE_URL}/login?redirect=/pricing`;
